import Card from '@/components/elements/Card/Card';
import { Button } from '@/components/elements/forms/buttons';
import { ListItem, ListItemContent } from '@/components/elements/lists';
import Icon from '@/components/icons/Icon';
import { capitalizeFirstLetter } from '@/helpers';
import { _s } from '@/locale';
import { PLACE_IMPRESSION, placeService } from '@/services';
import { Place } from '@/types/state/shared';

const baseTranslationKey = 'components.modules.place.Address';

type AddressProps = {
  place: Place;
  onAddAddressClick?: () => void;
};

const Address = ({ place, onAddAddressClick }: AddressProps) => {
  const address = place.contact && place.contact.address ? place.contact.address : null;
  const isVerified =
    place.isVerifiedExternalPlace || place.about?.settings?.subscriptionType?.toLowerCase() !== 'profilepagepremium';
  const addressString = address?.street
    ? [address.street, address.zipcode, address.city].filter(Boolean).join(', ').replace(/ /g, '+')
    : undefined;

  const handleAddressClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    placeService.storePlaceImpressions([place.id], PLACE_IMPRESSION.PLACE_ADDRESS_CLICK);
  };

  return (
    <Card size="lg">
      <div className="gap-xs flex flex-col">
        <h2 className="text-h-s">{_s(`${baseTranslationKey}.title`)}</h2>
        <ul>
          {!isVerified && !address?.street && (
            <ListItem
              leftPadding={false}
              underline
              className="gap-sm"
              leftSlot={<Icon variant="shop" color="fg_secondary" />}>
              <Button variant="link" className="text-l text-fg_link !p-0 underline" onClick={onAddAddressClick}>
                {_s(`${baseTranslationKey}.cta`)}
              </Button>
            </ListItem>
          )}
          {isVerified && address?.street && (
            <ListItem
              className="gap-sm"
              leftPadding={false}
              underline
              leftSlot={<Icon variant="shop" color="fg_secondary" />}>
              <a
                className="text-l text-fg_link underline"
                target="_blank"
                rel="noreferrer"
                href={`https://www.google.com/maps/search/?api=1&query=${addressString}`}
                onClick={handleAddressClick}>
                {address.street}
              </a>
            </ListItem>
          )}
          <ListItem className="gap-sm" leftPadding={false} leftSlot={<Icon variant="location" color="fg_secondary" />}>
            <ListItemContent
              subTitle={`${address.zipcode ? address.zipcode : ''}${address.zipcode && address.city ? ', ' : ''}${
                address.city ? capitalizeFirstLetter(address.city) : ''
              }`}
            />
          </ListItem>
        </ul>
      </div>
    </Card>
  );
};

export default Address;
